module.exports = __webpack_public_path__ + "img/settings-purple.e3e0fb2a.svg";